import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from '../../../services/user/user.service';
import { LocalStorage } from '@ngx-pwa/local-storage';


import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { PeersService } from '../../../services/peers/peers.service';


import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';

export interface DialogData {
    usersCrm: any;
    binas: any;
}


@Component({
    selector: 'app-add-peers',
    templateUrl: './add-peers.component.html',
    styleUrls: ['./add-peers.component.scss']
})
export class AddPeersComponent implements OnInit {

    public loading = false;

    myControl = new FormControl();
    public options;
    filteredOptions: Observable<string[]>;

    public payload;
    public usersCrm;
    public binas;

    public externalCall = 0;
    public mobileCall = 0;
    public voicemail = 0;
    public recordCall = 0;
    public accessRecords = 0;
    public downloadRecords = 0;
    public smart_bina = 0;
    public peer_number;
    public bina = 0;

    constructor(
        public dialogRef: MatDialogRef<AddPeersComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public userService: UserService,
        public localStorage: LocalStorage,
        public peersService: PeersService,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.localStorage.getItem("payload").subscribe((payload) => {
            this.payload = payload;
        })
        this.usersCrm = this.data.usersCrm;
        this.binas = this.data.binas;
        this.options = this.data.usersCrm;
        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.nome),
                map(nome => nome ? this._filter(nome) : this.options.slice())
            );
    }

    displayFn(user): string | undefined {
        return user ? user.nome : undefined;
    }

    onNoClick(): void {

        this.dialogRef.close();
    }

    private _filter(nome: string) {
        const filterValue = nome.toLowerCase();

        return this.options.filter(option => option.nome.toLowerCase().indexOf(filterValue) === 0);
    }

    changePeerNumber() {
        var peer_number = this.peer_number.split("");
        var new_value = "";
        peer_number.forEach((item) => {
            if(!isNaN(item)) {
                new_value += item;
            }
        })
        this.peer_number = new_value;
    }

    save() {
        this.loading = true;
        if (this.myControl.value) {
            var accessRecords;
            var downloadRecords;

            if (this.recordCall == 0) {
                accessRecords = 0;
                downloadRecords = 0;
            } else {
                accessRecords = JSON.parse(JSON.stringify(this.accessRecords));
                downloadRecords = JSON.parse(JSON.stringify(this.downloadRecords));
            }
            this.peersService.add(
                this.myControl.value,
                this.peer_number,
                this.bina,
                this.externalCall,
                this.mobileCall,
                this.voicemail,
                this.recordCall,
                accessRecords,
                downloadRecords,
                this.smart_bina
            ).subscribe((res) => {
                this.loading = false;
                if(res.success){
                    this.snackBar.openFromComponent(ToastComponent, {
                        data: res.msg
                    });
                    this.dialogRef.close();
                }else{
                    this.snackBar.openFromComponent(ToastComponent, {
                        data: res.msg
                    });
                }
            })
        }else{
            this.loading = false;
            this.snackBar.openFromComponent(ToastComponent, {
                data: "Selecione um usuário"
            });
        }

    }

}
